import client from "./client";
import { LibraryGroup, Library, LibraryTerm, LibraryTermRequest } from "@/interfaces";

export const getLibraries = () => client.get<LibraryGroup[]>("libraries");
export const getLibrary = (libraryName: string) => client.get<Library>(`libraryterms/${libraryName}`);
export const createLibraryTerm = (data: LibraryTermRequest) => client.post<LibraryTerm>("libraryterms", { ...data });
export const updateLibraryTerm = (id: number, data: LibraryTermRequest) =>
  client.put<any>(`libraryterms/${id}`, { ...data });
export const deleteLibraryTerm = (id: number) => client.delete<any>(`libraryterms/${id}`);
